import { Steps } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { getArrayDocDataByRef } from "../models/DataFunctions";
import Icon1 from "../icons/Icon";

const TimelineFolder = ({ folderData, clientData }) => {
  const steps_titles = [
    "Dossier créé",
    "Xml déposé",

    "RDV planifié",
    "Contrôle réalisé",
    "Documents administratifs déposés",
    "Signatures et photos complétées",
    "Mise à jour thermique",
    "Rapports rédigés",
    "Rapports payés",
  ];

  const [current, setCurrent] = useState(0);

  const handleTimeline = async (folderData, clientData) => {
    let current = 1;

    if (folderData.reglement_state === "done") {
      current = steps_titles.length;
      setCurrent(current);
      return;
    }

    if (
      folderData.xml?.state === "done" ||
      folderData.modif_thermal.activated
    ) {
      current = 2;

      if (folderData.dateintervention) {
        current = 3;
        if (folderData.reglement_state === "initialised") {
          current = steps_titles.length - 1;
          setCurrent(current);
          return;
        }
        if (new Date(folderData.dateintervention.seconds * 1000) < Date.now()) {
          current = 4;

          // counters is an array with dict and counter key, sum of all counters
          let documents = await getArrayDocDataByRef(folderData.documents);
          let all_done = true;
          for (let doc of documents) {
            if (doc.state === "locked" && doc.icon === "file") {
              current = 4;
              all_done = false;
              break;
            }
          }

          if (all_done) {
            current = 5;

            let documents = await getArrayDocDataByRef(folderData.documents);
            let all_done = true;
            for (let document of documents) {
              if (document.state !== "done") {
                all_done = false;
                break;
              }
            }
            if (all_done) {
              current = 6;

              if (folderData.modif_thermal.state === "done") {
                current = 7;
              }
            }
          }
        }
      }
    }
    setCurrent(current);
  };

  useEffect(() => {
    const steps = steps_titles
      .filter((title, index) => {
        return (
          folderData.client_type !== "constructor" || title !== "Rapports payés"
        );
      })

      .map((title, index) => {
        return { title: title, description: "" };
      });

    handleTimeline(folderData, clientData);

    setSteps(steps);
  }, [folderData, clientData]);

  const [steps, setSteps] = useState([]);

  return (
    <div className="flex flex-col  w-full  ">
      <BetterSteps items={steps} current={current} />
    </div>
  );
};

export default TimelineFolder;

export const BetterSteps = ({ items, current }) => {
  return (
    <div className="flex items-center justify-center flex-col gap-4  w-full">
      <div className="flex flex-row justify-between w-full ml-16 min-h-fit">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex w-full h-4 flex-row items-center justify-start min-h-fit "
          >
            <div
              className={` min-w-8 h-8 rounded-full items-center justify-center flex  ${index < current ? "bg-green-50" : index === current ? "bg-blue-50" : "bg-gray-50"}`}
            >
              <Icon1
                icon_name={
                  index < current
                    ? "done2"
                    : index === current
                      ? "warning"
                      : "horloge"
                }
                size={20}
                fill={
                  index < current
                    ? "#0cf480"
                    : index === current
                      ? "#0071ff"
                      : "lightgrey"
                }
              />
            </div>
            {index !== items.length - 1 && (
              <div
                className={` w-full  h-0.5 rounded-full  px-1 ${index < current - 1 ? "bg-green-100" : index === current - 1 ? "bg-blue-200" : "bg-gray-100"}`}
              ></div>
            )}
          </div>
        ))}
      </div>
      <div className="flex flex-row justify-between w-full ml-8 pr-2  gap-2 min-h-fit items-start">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex flex-1  w-1/12 items-center justify-start min-h-fit"
          >
            <div
              className={`text-h4 min-h-fit  font-medium ${index < current ? "text-shadow_50" : index === current ? "text-black" : "text-shadow_25"}`}
            >
              {item.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
